import { ChevronLeft as ChevronLeftIcon } from '@mui/icons-material'
import { Box, Button, Container, Paper, Typography } from '@mui/material'
import React from 'react'
import { useLocation } from 'react-router'
import { T } from '@/helpers/T'
import { useNavigateGoBack } from '@/hooks/useNavigateGoBack'

//	///////////////////////
//	MARK: EXPORTS
const E401Index: React.FC<{
  roles?: string[]
}> = ({ roles }) => {
  const location = useLocation()
  const navigateGoBack = useNavigateGoBack()

  return (
    <Container maxWidth='sm' sx={{ mt: 4, textAlign: 'center' }}>
      <Paper sx={{ p: 5 }}>
        <Typography variant='h3' mb={2}>
          <T id='r.401.title' />
        </Typography>
        <Typography variant='h6' color='primary' mb={2}>
          {location.pathname}
        </Typography>
        <Typography variant='body1' mb={roles && roles.length > 0 ? 2 : 3}>
          <T id='r.401.text' />
        </Typography>
        {roles && roles.length > 0 && (
          <Box mb={2} textAlign='center'>
            {roles.map((role) => (
              <Typography
                key={role}
                variant='caption'
                display='inline-block'
                p={1}
                mr={1}
                mb={1}
                bgcolor='grey.100'
              >
                {role}
              </Typography>
            ))}
          </Box>
        )}
        <Button startIcon={<ChevronLeftIcon />} onClick={navigateGoBack}>
          <T id='r.401.button' />
        </Button>
      </Paper>
    </Container>
  )
}

export default React.memo(E401Index)
